import { faker } from '@faker-js/faker'

import { FAVORITE_OPERATION_TYPE, UserOperationType } from '../../contracts/treatment/UserOperationType'
import { asBuilder } from '../asBuilder'

export const getUserOperationType = asBuilder<UserOperationType>((): UserOperationType => {
  return {
    operationType: faker.helpers.enumValue(FAVORITE_OPERATION_TYPE),
  }
})
